import { Modal } from '@sede-enterprise/shell-ds-react-framework';
import { cxTheme } from 'components/storybook-migration/theme-provider/system-design/theme';
import { AppThemeType } from 'store/types';
import styled from 'styled-components';

export const FullScreenModal = styled(Modal)<{
  $showMask: boolean;
  $appTheme: AppThemeType;
  $mobileLandscape: boolean;
  $narrowMobile: boolean;
}>`
  &.shell-modal.shell-modal-container-wrap {
    z-index: 100;
    overflow: hidden;
  }

  &.shell-modal.shell-modal-container-mask {
    z-index: 2;
  }

  &.shell-modal-container {
    width: calc(100vw - 88px) !important;

    @media screen and (max-width: ${cxTheme.breakpoints.tablet}px) {
      width: 100vw !important; // ugly but need to set it to counter hard-coded 520px width
      height: 100vh !important;
      position: fixed;
      top: 0;
      left: 0;
    }
  }

  &.shell-modal-container-content {
    border-radius: 0;

    @media screen and (min-width: ${cxTheme.breakpoints.tablet}px) {
      border-radius: 6px;
    }

    @media screen and (max-width: ${cxTheme.breakpoints.tablet}px) {
      height: 100vh !important;
    }
  }

  &.shell-modal-container-body {
    max-height: 100%;
  }

  ${({ theme, $showMask, $appTheme, $mobileLandscape, $narrowMobile }) => `
      &.shell-modal-container {
        ${
          $mobileLandscape &&
          `width: 100vw !important;
          height: 100vh !important;
          position: fixed;
          top: 0;
          left: 0;`
        }
      }
      
      &.shell-modal-container-content {
        ${
          $mobileLandscape &&
          `border-radius: 0 !important;
            height: 100vh;`
        }
      }
  
      &.shell-modal.shell-modal-container-mask {
        ${
          $showMask &&
          `background-color: ${$appTheme === 'light' ? '#F5F5F5;' : `${theme.background.base};`}`
        }
      }

      &.shell-modal-container-body {
        ${$narrowMobile && `overflow: auto;`}
      }
    `}
`;
